module.exports = __webpack_public_path__ + "static/img/flow-3.47f51e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/visa-api/flow-3.png
// module id = wHsU
// module chunks = 4